import * as tokens from "./tokens";
import * as variants from "./variants";
import styles from "./styles";

export const theme = {
  ...tokens,
  styles,
  ...variants,
};
